import _ from 'lodash';
import M from 'moment';

import * as VueGoogleMaps from 'vue2-google-maps';
import VueMasonry from 'vue-masonry-css';
// import Notifications from 'vue-notification';
// import Vue2TouchEvents from 'vue2-touch-events'
import { Pagination } from 'bootstrap-vue/es/components';

import bootstrapdatetimepicker from 'bootstrap-datetimepicker-npm';

// sentry integration
import * as Sentry from '@sentry/browser';
import { Vue as VueIntegration } from '@sentry/integrations';

// Sentry.init({
//   dsn: window.env.SENTRY_VUE_DSN,
//   integrations: [new VueIntegration({Vue, attachProps: true})],
// });

// import main from './store/main';
import getHelpers from './helpers';

const libs = {};
window.exportLib = (key, value) => {
    libs[key] = value;
}

window.importLib = (key) => {
    return libs[key];
}

// Vue.use(Vuex);
// Vue.use(Notifications);
// Vue.use(Vue2TouchEvents);
Vue.use(VueMasonry);
Vue.use(Pagination);
Vue.use(VueGoogleMaps, {
    load: {
        key: window.env.GOOGLE_MAP_KEY,
        libraries: "places" // necessary for places input
    }
});

// Define GTM dataLayer object
window.gtmDataLayer = {
    contact: {
        form_type: { static: 'Contact Us' },
        message_id: { var: 'id' },
        Name: { var: 'name' },
        Email: { var: 'email' },
        Phone: { var: 'phone' },
        Inquiry: { var: 'content' },
        event: { static: 'form_submission' },
    },
    application: {
        form_type: { static: 'Apply Now' },
        message_id: { var: 'id' },
        Title: { var: 'title' },
        event: { static: 'form_submission' },
        'First Name': { var: 'firstname' },
        'Last Name' : { var: 'lastname' },
        'Middle Name' : { var: 'middlename' },
        'Email': { var: 'email' },
        'Date of Birth': { var: 'dob' },
        'Type of Surgery': { var: 'procedure.name' },
        'Surgeon': { var: 'doctor.name' },
        'Appointment': { var: 'confirm_appointment' },
        'How much would you like to borrow': { var: 'loan_amount' },
        'What Loan Term': { var: 'loan_term' },
        'Your estimated monthly repayment': { var: 'monthly_payment' },
        'How much do you earn after tax each month': { var: 'income' },
        'What are your monthly expenses including any existing loan repayments': { var: 'expense' },
        'Residency': { var: 'residency' },
        // 'Have you ever had any adverse credit registered with a credit agency': { var: 'adverse_credit' },
        'Do you own any vehicles': { var: 'own_vehicle' },
        'Do you own a home or are you renting?': { var: 'housing_status' },
        'Would you like to apply jointly with your partner or spouse?': { var: 'joint_application' },
    },
};

// var store = new Vuex.Store(main);
// window.store = store;
window.mountVueComponent = (id, component) => {
    var root = document.getElementById(id);
    if (root) {
        var data = null;
        var config = null;

        try {
            var content = root.textContent;
            content = JSON.parse(content);
            data = content.data || null;
            config = content.config || null;

        } catch (e) {
            console.info(`Problem parsing data and config for component ${id}`);
        }

        new Vue({
            el: root,
            render: h => h(component, {
                props: { initialData: data, config }
            }),
        })
    }
}

window.exportLib('lodash', _);
window.exportLib('moment', M);
// window.exportLib('Vuex', Vuex);
window.exportLib('getHelpers', getHelpers);
window.dispatchEvent(new CustomEvent('vue-init'));

_.chain(document.querySelectorAll('script[data-src]'))
    .map((el) => {
        el.src = el.dataset.src;
    })
    .value();

/**
 * GoogleMap init
 *
 */
window.vueGoogleMapsInitOld = window.vueGoogleMapsInit
window.vueGoogleMapsInit = (value) => {
    // google is now available to global scope

    window.dispatchEvent(new CustomEvent('gmap-init'));
    return window.vueGoogleMapsInitOld(value);
}

window.recaptchaInit = function () {
    $(".g-recaptcha").each(function() {
        var el = $(this);
        if (grecaptcha) {
            grecaptcha.render($(el)[0], {});
        }
    });
    window.dispatchEvent(new CustomEvent('recaptcha-init'));
}



// WEBPACK FOOTER //
// ./resources/assets/site/js/vue-init.js